import(/* webpackMode: "eager" */ "/home/runner/work/yardzen/yardzen/apps/yardzen-for-pros/app/global-error.tsx");
